import React, { FC, Ref, memo } from 'react';
import styled from "@emotion/styled";

type CanvasProps = {
  canvasRef: Ref<HTMLCanvasElement>
}

export const Content = styled.div`
  //width: 800px;
  //height: 800px;
  //pointer-events: none
`;

const Canvas: FC<CanvasProps> = ({ canvasRef }) => {
  return (
    <Content>
      <canvas ref={canvasRef}  />
    </Content>
  )
}

export default memo(Canvas);
